import {
  ApiClient,
  ApiClientContext,
  ApiClientOptions,
  RouteOptions,
  defaultAxiosConfig,
} from '@qualifio/api-client';
import { AxiosInstance } from 'axios';
import { PremiumGame } from './types/premium-game';

export class PremiumGamesApiClient extends ApiClient {
  static serviceName = 'premium-games-api';

  constructor(http?: AxiosInstance, context?: ApiClientContext, options?: ApiClientOptions) {
    super('/mfe/premium-games/api', http, context, options);
  }

  /** Games available to a tenant, grouped per advanced format type. */
  async getGames(tenantId: string, options?: RouteOptions): Promise<PremiumGame[]> {
    const { data } = await this.http.get('/games', {
      ...defaultAxiosConfig(options),
      params: { ...options?.params, tenantId },
    });
    return data?.games ?? [];
  }
}
